import ST from "gsap/ScrollTrigger";
export const ScrollTrigger = ST;
